export const systemZhCN = {
  // LegalPage
  'system.legal.fallbackTitle': '文档',
  'system.legal.fallbackBody': '未找到。',
  'system.legal.lastUpdated': '最后更新于 {date}',

  // NotFoundPage
  'system.notFound.seoTitle': '迷失在薄纱之中',
  'system.notFound.heading': '你已踏入地图的边缘之外',
  'system.notFound.body': '你追寻的道路已被永恒的暮光吞没。',
  'system.notFound.returnCta': '返回薄纱',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': '未知的扰动震撼了薄纱。',
  'system.error.seoTitle': '薄纱的异变',
  'system.error.heading': '仪式失败了',
  'system.error.body':
    '无形的力量扰乱了此页面。薄纱在此处异常脆弱——请重试，或返回安全的地方。',
  'system.error.tryAgain': '重试',
  'system.error.returnCta': '返回薄纱',
  'licenseGate.heading': "即将推出 — 授权限制",
  'licenseGate.body': "由于授权原因，此语言版本暂未开放。敬请期待，请稍后再来。",
} as const
